import React from "react";
import MatrixOSEnterPage from "./MatrixOSEnterPage";

export default function HomePage() {
  return <MatrixOSEnterPage />;
}
